import { queryClient } from '@src/api/queryClient';
import { DASHBOARD_QUERY_KEYS } from '@api/services/dashboard';
import { ADDITIONAL_INFO_QUERY_KEYS } from '@api/services/additional-info';
import { useUserRoleCapabilities } from '@stores';

export const resetRoleData = () => {
  useUserRoleCapabilities.getState().clearUserRoleCapabilities();

  queryClient.removeQueries({
    queryKey: [DASHBOARD_QUERY_KEYS.GET_DASHBOARD],
    exact: false, // Remove all dashboard query variants, including role-scoped keys
  });

  queryClient.removeQueries({
    queryKey: [ADDITIONAL_INFO_QUERY_KEYS.GET_ALL_REQUESTS],
    exact: false, // Remove all additional info query variants, including pagination/filter/sort keys
  });
};
